module.exports = __webpack_public_path__ + "img/75692.69d772ee.svg";